module.exports = __webpack_public_path__ + "static/credit_card-90754651bcf82924b1d3a1cb3352256c.svg";